import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './input.css';
import { RecoilRoot } from 'recoil';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { PayrollAuthProvider } from './context/PayrollAuthContext';
/* 계정 전환 때 캐시를 비워야 해서 provider 바깥에서도 잡히는 곳에 둔다 */
import { queryClient } from './lib/queryClient';
import { OverlayProvider } from 'overlay-kit';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <RecoilRoot>
            <QueryClientProvider client={queryClient}>
                <OverlayProvider>
                    <PayrollAuthProvider>
                        <HelmetProvider>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </HelmetProvider>
                    </PayrollAuthProvider>
                </OverlayProvider>
            </QueryClientProvider>
        </RecoilRoot>
    </React.StrictMode>
);
